import React from "react";
import "./style.css";
import { NavLink } from "react-router-dom";
import {
  FaGithub,
  FaTwitter,
  FaFacebookF,
  FaLinkedin,
  FaYoutube,
  FaTwitch,
} from "react-icons/fa";
import { MdRecordVoiceOver } from "react-icons/md";
import { socialprofils } from "../../content_option";

export const Socialicons = (params) => {
  return (
    <div className="stick_follow_icon">
      <ul>
        {/* Điều hướng nội bộ — dùng NavLink chứ không phải <a href>, nếu không
            trang sẽ reload và mất hiệu ứng chuyển trang */}
        <li className="sd_nav_item">
          <NavLink
            to="/shadowing"
            title="Japanese Shadowing"
            aria-label="Japanese Shadowing"
            className={({ isActive }) => (isActive ? "is-active" : undefined)}
          >
            <MdRecordVoiceOver />
          </NavLink>
        </li>
        {socialprofils.twitter && (
          <li>
            <a href={socialprofils.twitter}>
              <FaTwitter />
            </a>
          </li>
        )}
        {socialprofils.github && (
          <li>
            <a href={socialprofils.github}>
              <FaGithub />
            </a>
          </li>
        )}
        {socialprofils.facebook && (
          <li>
            <a href={socialprofils.facebook}>
              <FaFacebookF />
            </a>
          </li>
        )}
        {socialprofils.linkedin && (
          <li>
            <a href={socialprofils.linkedin}>
              <FaLinkedin />
            </a>
          </li>
        )}
        {socialprofils.youtube && (
          <li>
            <a href={socialprofils.youtube}>
              <FaYoutube />
            </a>
          </li>
        )}
        {socialprofils.twitch && (
          <li>
            <a href={socialprofils.twitch}>
              <FaTwitch />
            </a>
          </li>
        )}
      </ul>
      <p>Follow Me</p>
    </div>
  );
};
